import React, { memo } from 'react'
import { TextProps, Text, Box } from '@chakra-ui/react';

interface FormatNumberProps {
  value: number
  style?: 'currency' | 'decimal' | 'percent'
  currency?: string
  locale?: string
  textProps?: TextProps;
}

const FormatNumber= ({value, style= 'decimal', currency ='USD', locale= 'en-US', textProps}: FormatNumberProps) => {
  const formatter = new Intl.NumberFormat(locale, {
    style,
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });


  const formattedValue:string = formatter.format(value).slice(1);
  return <>
    <Text {...textProps}>
      <Box as="span" color="neutral.400">$</Box> {formattedValue}
    </Text>
  </>
}

export default memo(FormatNumber)
